import { render, staticRenderFns } from "./form.vue?vue&type=template&id=45cf8b76&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=45cf8b76&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf8b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cf8b76')) {
      api.createRecord('45cf8b76', component.options)
    } else {
      api.reload('45cf8b76', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=45cf8b76&scoped=true", function () {
      api.rerender('45cf8b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/bill/remittance/form/form.vue"
export default component.exports